module.exports = __webpack_public_path__ + "img/invector-logic.ef031789.png";